import { NftType } from '@src/constants/bookmark'
import { Bookmark } from '@src/types/bookmark'
import * as yup from 'yup'

export const bookmarkSchema: yup.SchemaOf<Bookmark> = yup
  .object({
    nftType: yup.mixed().oneOf(Object.values(NftType)).default(NftType.Planet),
    tokenId: yup.string().default(''),
    isBookmarked: yup.boolean().default(false)
  })
  .from('tokenID', 'tokenId')
